export default "__VITE_ASSET__DOPsf8ek__"